module.exports = __webpack_public_path__ + "static/media/Cafe_Logo.45d51168.svg";